import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            资源分类导航
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            科学分类，快速定位，八大资源频道满足您的各种需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all mb-4">
                <i className={`${cat.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-800 group-hover:text-primary-600 transition-colors mb-1">
                {cat.name}
              </h3>
              <span className="text-xs text-foreground-400">
                {cat.articleCount} 篇资源
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}